import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FlowButton from './FlowButton';

function ConfirmButton ({onClick, name}) {
    
    return <FlowButton className='baseElementsconfirmButton' onClick={onClick} name={name?name:"Conferma"}></FlowButton>
}

export default ConfirmButton;